import React, {useEffect} from 'react'
import AppContainer from "../../components/container/AppContainer";
import Text from "../../components/text/Text";
import Colors from "../../styles/Colors";
import Section from "../../components/container/Section";
import Button from "../../components/button/Button";
import NavigationService from "../../services/NavigationService";
import ThirtyThreePercentCard from "../../components/card/ThirtyThreePercentCard";
import styled from "@emotion/styled";
import Accueil from "../../assets/images/Accueil.png"
import {GAEvent, GAPageView} from "../../services/AnalyticsService";

const Home = () => {
    const onEstimateButtonClick = () => {
        GAEvent("Navigation", "Home Button click", "Button")
        NavigationService.navigate("/prestation", "Nos prestations")
        window.dispatchEvent(new Event("location change"))
    }

    useEffect(() => {
        GAPageView("Home")
    }, []);

    return (
        <AppContainer>
            <Section marginVertical={50} paddingHorizontal={20}>
                <TitleContainer>
                    <Text
                        type={"h4"}
                        color={Colors.green}
                    >
                        En quoi consiste l’éco-pâturage ?
                    </Text>
                </TitleContainer>

                <Text>
                    Ecopatu’Rhin définit l’éco-pâturage comme une solution alternative à l’entretien mécanique et
                    phytosanitaire des espaces paysagers, en milieu urbain et périurbain par des animaux herbivores.
                    Ils sont particulièrement appréciés sur les terrains en pente ou fortement enfrichés et
                    inaccessibles aux engins traditionnels. Nous utilisons une technique de pâturage extensif tournant
                    adaptable selon le résultat attendu.
                </Text>

                <Image src={Accueil} alt={"Illustration de l'écopatûrage"}/>
            </Section>

            <Section paddingHorizontal={20}>
                <TitleContainer>
                    <Text
                        type={"h4"}
                        color={Colors.green}
                    >
                        Une solution au cœur du développement durable
                    </Text>
                </TitleContainer>

                <Text>
                    ECOPATU’RHIN c’est une proposition qui s’inscrit dans le cadre du développement durable par ces 3
                    dimensions:
                </Text>
            </Section>

            <Section
                flexDirection={"row"}
                marginVertical={70}
            >
                <ThirtyThreePercentCard>
                    <TitleContainer>
                        <Text
                            type={"h5"}
                            color={Colors.green}
                        >
                            Une dimension Environnementale
                        </Text>
                    </TitleContainer>

                    <TextContainer>
                        <Text>
                            L’éco-pâturage s’intègre dans une politique de suppression des produits phyto-sanitaires.
                        </Text>
                    </TextContainer>

                    <TextContainer>
                        <Text>
                            Les animaux maintiennent la végétation en prairie tout au long de l’année et les insectes
                            pollinisateurs peuvent facilement s’y développer.
                        </Text>
                    </TextContainer>

                    <TextContainer>
                        <Text>
                            Quant aux déjections des moutons et des chèvres celles-ci se désintègrent rapidement dans le
                            sol et créent un engrais naturel bénéfique pour les micro-organismes.
                        </Text>
                    </TextContainer>

                    <TextContainer>
                        <Text>
                            C’est en moyenne un enrichissement de la faune et de la flore de plus de 30 % comparé à un
                            entretien mécanique.
                        </Text>
                    </TextContainer>
                </ThirtyThreePercentCard>

                <ThirtyThreePercentCard>
                    <TitleContainer>
                        <Text
                            type={"h5"}
                            color={Colors.green}
                        >
                            Une dimension Sociale
                        </Text>
                    </TitleContainer>

                    <TextContainer>
                        <Text>
                            La présence des animaux est avant tout apaisante.
                        </Text>
                    </TextContainer>

                    <TextContainer>
                        <Text>
                            De plus, leur compagnie peut être particulièrement intéressante car les animaux peuvent
                            jouer le rôle de médiateurs.
                        </Text>
                    </TextContainer>

                    <TextContainer>
                        <Text>
                            Ils permettent ainsi des échanges spontanés et des liens se créent au sein des structures.
                            Que ça soit au niveau des entreprises, des collectivités, ou encore des E.H.P.A.D, les
                            animaux participent à la construction d’un lien social entre les différents acteurs.
                        </Text>
                    </TextContainer>

                    <TextContainer>
                        <Text>
                            Les nuisances sonores des engins mécaniques sont supprimées, tout comme les accidents du
                            travail sont réduits.
                        </Text>
                    </TextContainer>
                </ThirtyThreePercentCard>

                <ThirtyThreePercentCard>
                    <TitleContainer>
                        <Text
                            type={"h5"}
                            color={Colors.green}
                        >
                            Une dimension Economique
                        </Text>
                    </TitleContainer>

                    <TextContainer>
                        <Text>
                            Certains de nos clients peuvent réaliser jusqu’à 25% d’économie sur leur budget de tonte ou
                            d’entretien en comparaison à de l’entretien mécanique.
                        </Text>
                    </TextContainer>

                    <TextContainer>
                        <Text>
                            Notre offre est fixe, sans surprise et régionale. Elle permet à nos clients de se consacrer
                            pleinement à leur activité.
                        </Text>
                    </TextContainer>

                    <ButtonContainer>
                        <Button onClick={onEstimateButtonClick}>
                            Obtenir un devis
                        </Button>
                    </ButtonContainer>
                </ThirtyThreePercentCard>
            </Section>
        </AppContainer>
    )
}

export default Home

const TitleContainer = styled.div`
  margin-bottom: 25px;
`

const TextContainer = styled.div`
  margin-bottom: 15px;
`

const ButtonContainer = styled.div`
  margin-top: 50px;
`

const Image = styled.img`
  width: 90%;
  height: 90%;
  
  @media (max-width: 768px) {
    margin-top: 20px;
    width: 100%;
    height: 100%;
  }
`
